import React from "react";
import DayIndexSinceFirstJanuary from "./helpers/DayIndexSinceFirstJanuary";
import BuildCrosswordJson from "./BuildCrosswordJson";
import crosswordData from "./jsonData/crosswordsData.json";

const BoardElementsJson = () => {
  const chosenItemNum = DayIndexSinceFirstJanuary();
  const chosenCrossword = crosswordData.data[chosenItemNum];

  return (
    <React.Fragment>
      <BuildCrosswordJson chosenCrossword={chosenCrossword} />
    </React.Fragment>
  );
};

export default BoardElementsJson;
